// extracted by mini-css-extract-plugin
module.exports = {"clickable_label_fix":"beschikbare-verzekeraars_clickable_label_fix__SkHAT","align_center":"beschikbare-verzekeraars_align_center__3R7Qg"};